<template>
  <div class="mb-3 flex aspect-[24/33] items-center justify-center bg-white">
    <NuxtImg
      v-if="src"
      :src="src"
      :alt="alt"
      :width="sizes?.w"
      :height="sizes?.h"
      :sizes="imageSize"
    />
    <template v-else>
      <slot name="fallback" />
    </template>
    <slot name="meta" />
  </div>
</template>

<script setup lang="ts">
import type { GridClass } from "~/@types/feed"

const props = withDefaults(
  defineProps<{
    src?: string
    alt?: string
    sizes?: {
      w: number
      h: number
    }
    gridSizes?: GridClass
  }>(),
  {
    gridSizes: () => ({
      sm: true,
      md: true,
    }),
  },
)

const { gridSizes } = toRefs(props)

const imageSize = computed(() => {
  let sizes = ["50vw", "sm:171px", "md:116px"]

  if (gridSizes.value.sm && !gridSizes.value.md) {
    delete sizes[2]
  } else if (!gridSizes.value.sm && !gridSizes.value.md) {
    sizes = ["50vw", "sm:280px"]
  }

  return sizes.join(" ")
})
</script>
